import script from "./VideoFromNet.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoFromNet.vue?vue&type=script&setup=true&lang=js"

import "./VideoFromNet.vue?vue&type=style&index=0&id=6ad072ca&lang=css"

const __exports__ = script;

export default __exports__